import * as amplitude from "@amplitude/analytics-browser";

let isInitialized = false;

/**
 * Initialize Amplitude SDK
 */
function init() {
  amplitude.init(process.env.VUE_APP_AMPLITUDE_API_KEY, {
    autocapture: false,
    serverZone: "EU",
  });

  isInitialized = true;
  return true;
}

/**
 * Track a custom event
 * @param {string} eventName - Name of the event
 * @param {Object} eventProperties - Optional properties for the event
 */
function track(eventName, eventProperties = {}) {
  if (!isInitialized) {
    console.warn("[Amplitude] SDK not initialized. Call init() first.");
    return;
  }
  amplitude.track(eventName, eventProperties);
}

const amplitudeService = {
  init,
  track,
};

export default {
  install(app) {
    init();
    app.provide("amplitude", amplitudeService);
  },
};

export { amplitudeService };
